export const project_url = "lms";
export const admin_url = "FmHf394U4S2Z";
export const media_url = "https://predictal.com/lms/media/";
export const secretPass = "XkhZG4fW2t2W";
export const seo_tag_config = true;
export const content_display_config = true;
